// Version utility for deployment tracking and debugging
import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;
export const APP_NAME = packageJson.name;

// Build timestamp (will be injected at build time)
export const BUILD_TIMESTAMP = new Date().toISOString();

// Environment detection
export const ENVIRONMENT = import.meta.env.MODE;
export const IS_PRODUCTION = import.meta.env.PROD;
export const IS_DEVELOPMENT = import.meta.env.DEV;

// Version logging utility
export const logAppVersion = () => {
  const styles = {
    banner: 'background: linear-gradient(90deg, #0066cc, #004499); color: white; padding: 8px 16px; border-radius: 4px; font-weight: bold; font-size: 14px;',
    info: 'color: #0066cc; font-weight: bold;',
    env: IS_PRODUCTION ? 'color: #28a745; font-weight: bold;' : 'color: #ffc107; font-weight: bold;'
  };

  console.log(`%c🚀 ${APP_NAME.replace(/-/g, ' ').toUpperCase()} v${APP_VERSION}`, styles.banner);
  console.log(`%c📦 Build: ${BUILD_TIMESTAMP}`, styles.info);
  console.log(`%c🌍 Environment: ${ENVIRONMENT}`, styles.env);
  console.log(`%c🔧 Mode: ${IS_PRODUCTION ? 'Production' : 'Development'}`, styles.env);
  
  // Add deployment verification
  if (IS_PRODUCTION) {
    console.log('%c✅ Production deployment verified', 'color: #28a745; font-weight: bold;');
  }
};

// Component version logger
export const logComponentVersion = (componentName: string, action?: string) => {
  const actionText = action ? `: ${action}` : '';
  console.log(`%c${componentName} v${APP_VERSION}${actionText}`, 'color: #666; font-size: 12px;');
};

// Error reporting with version context
export const logErrorWithVersion = (error: Error, context?: string) => {
  console.error(`%c❌ ERROR v${APP_VERSION}${context ? ` [${context}]` : ''}:`, 'color: #dc3545; font-weight: bold;', error);
};
